export const brand = {
    name: 'WellPath Fusion',
    tagline: 'Whole-person wellness, grounded in evidence.',
    email: 'hello@wellpathfusion.com'
}
